export default function PrivacyPolicy() {


    return (
        <div>
            <h1 className='text-3xl font-bold text-docpgrPurple text-center'>
                DocPGR Privacy Policy
            </h1>
            <div className="text-gray-800 flex flex-col pl-8 ">
                <p>
                    <strong>Effective Date: </strong> October 1, 2025
                </p>
                <p>
                    <strong>Company: </strong> DocPGR, LLC (“DocPGR,” “we,” “us,” “our”)
                </p>
                <p>
                    <strong>Website </strong> <a href='https://docpgr.com'>https://docpgr.com</a>
                </p>
                <p>
                    <strong>Contact: </strong> privacy@docpgr.com
                </p>
            </div>

            <nav className='my-10 '>
                <div className='border-t border-b border-docpgrPurple60 p-6 max-w-8xl mx-auto'>
                    <div className=''>
                        <h2 className='text-xs font-semibold uppercase trackingw-ider text-docpgrPurple mb-4'>Table of Contents</h2>
                        <ul className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3 text-sm'>
                            <li><a href='#scope' className='text-docpgrPurple90 hover:font-bold'>Scope</a></li>
                            <li><a href='#acreation' className='text-docpgrPurple90 hover:font-bold'>No In-App Account Creation</a></li>
                            <li><a href='#information' className='text-docpgrPurple90 hover:font-bold'>Information We Collect and Process</a></li>
                            <li><a href='#dataresidency' className='text-docpgrPurple90 hover:font-bold'>Data Residency (United States Only)</a></li>
                            <li><a href='#howweuseinfo' className='text-docpgrPurple90 hover:font-bold'>How We Use Information</a></li>
                            <li><a href='#thirdparty' className='text-docpgrPurple90 hover:font-bold'>Third-Party Service Providers</a></li>
                            <li><a href='#dataretention' className='text-docpgrPurple90 hover:font-bold'>Data Retention and Deletion</a></li>
                            <li><a href='#security' className='text-docpgrPurple90 hover:font-bold'>Security</a></li>
                            <li><a href='#privacy' className='text-docpgrPurple90 hover:font-bold'>Children's Privacy </a></li>
                            <li><a href='#changes' className='text-docpgrPurple90 hover:font-bold'>Changes to This Policy</a></li>
                            <li><a href='#contactus' className='text-docpgrPurple90 hover:font-bold'>Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className='text-justify text-gray-700 pl-8 mb-12'>
                <ol className='list-decimal pl-6 space-y-2'>
                    <li id='scope' className='font-bold'>Scope</li>
                    <p>This Privacy Policy describes how DocPGR collects, uses, shares, retains, and protects information within our platform and mobile applications (collectively, the “Service”). </p>
                    <li id='acreation' className='font-bold'>No In-App Account Creation</li>
                    <p>The DocPGR mobile application does not support in-app account creation. Accounts are provisioned through the platform by an authorized administrator. We collect and process only the minimum data required to facilitate secure login and Service functionality. </p>
                    <li id='information' className='font-bold'>Information We Collect and Process</li>
                    <p>We limit data collection to what is necessary to operate DocPGR. </p>
                    <ol className='list-[upper-alpha] pl-6 space-y-2'>
                        <li>
                            Account Data
                        </li>
                        <p>We do not store personal identifying information beyond:</p>
                        <ol className='list-disc pl-6 space-y-2'>
                            <li>Name of DocPGR user</li>
                            <li>Email address</li>
                            <li>Company Name</li>
                        </ol>
                        <li>Authentication Data</li>
                        <ol className='list-disc pl-6 space-y-2'>
                            <li>Login Credentials</li>
                            <p>Email address and credentials submitted for secure login</p>
                            <li>Password Handling</li>
                            <p>Passwords are not stored in plaintext. We store only a secure cryptographic representation (for example, salted hashing) and use access controls designed to protect authentication systems.</p>
                        </ol>
                        <li>Connectivity and Security Data</li>
                        <ol className='list-disc pl-6 space-y-2'>
                            <li>
                                IP Address and Request Metadata
                            </li>
                            <p>
                                Used solely for security monitoring, abuse prevention, rate limiting, load balancing, and incident investigation.
                            </p>
                        </ol>
                        <li>Delivery Data (Notification)</li>
                            <ol className='list-disc pl-6 space-y-2'>
                                <li>Device Tokens</li>
                                <p>
                                    Unique device tokens required to route push notifications to your device and/or DocPGR hardware.
                                </p>
                            </ol>
                        <li>
                            System Metadata
                            <ol className='list-disc pl-6 space-y-2'>
                                <li>
                                    Device/App Information
                                </li>
                                <p>
                                    Basic metadata such as OS version and app version, used to ensure compatibility, troubleshoot issues, and provide support.
                                </p>
                            </ol>
                        </li>
                        <p className='text-xs italic'>
                            Clinical Workflow and Data Boundaries (No Patient Identifiers)
                        </p>
                        <p className='text-xs italic'>
                            DocPGR is a professional workflow tool designed for operational efficiency and coordination. It is not a clinical database.
                        </p>
                        <ol className='list-disc pl-6 space-y-2 text-xs italic'>
                            <li>
                                Operational Statuses
                            </li>
                            <p>
                                The Service may facilitate workflow statuses (for example, “Post-op ready” or “Patient under anesthesia”) and scheduling metadata.
                            </p>
                            <li>
                                No Patient Identifiers / No PHI
                            </li>
                            <p>
                                We do not collect, store, or transmit patient names, Social Security numbers, dates of birth, or other patient identifiers. Users and integrated systems are prohibited from entering Protected Health Information (PHI) or other patient identifiers into the Service. If we discover patient identifiers were submitted, we may delete them to protect privacy and security.
                            </p>
                        </ol>
                    </ol>
                    <li id='dataresidency' className='font-bold'>Data Residency (United States Only)</li>
                    <p>
                        DocPGR is owned and operated within the United States. All DocPGR application data is hosted on servers located strictly within the United States. We do not transfer, store, or process DocPGR application data outside of U.S. jurisdiction. 
                        <br />
                        <br />
                        If our ownership, hosting model, or data storage location changes in a way that affects this statement, we will update this Privacy Policy prior to the change taking effect. 
                    </p>
                    <li id='howweuseinfo' className='font-bold'>How We Use Information</li>
                    <p>We use the information we collect strictly to:</p>
                    <ol className='list-disc pl-6 space-y-2'>
                        <li>Authenticate authorized users.</li>
                        <li>Route push notifications to the correct device.</li>
                        <li>Provide, maintain, and secure the Service.</li>
                        <li>Prevent unauthorized access, fraud, and abuse.</li>
                        <li>Troubleshoot issues and provide customer support.</li>
                        <li>Comply with legal obligations and enforce our terms.</li>
                        
                    </ol>
                    <p>We do not track users across third-party apps or websites, sell your data, share your data with data brokers or advertising platforms, or use personal information for targeted advertising. </p>
                    <li id='thirdparty' className='font-bold'>Third-Party Service Providers</li>
                    <p>
                        We share information only with essential service providers that help operate the Service (for example, U.S.-based hosting providers and notification gateways such as Apple APNs or Google FCM). These providers are authorized to process information only to deliver services to DocPGR and are prohibited from using the information for their own purposes. 
                        <br />
                        <br />
                        Push notifications: If you enable push notifications, Apple APNs and/or Google FCM will process device tokens and limited delivery metadata to route notifications to your device. DocPGR uses this information only to deliver notifications you request. 
                        <br />
                        <br />
                        We may also disclose information if required by law or legal process, or if we believe disclosure is necessary to protect the rights, safety, and security of DocPGR, our users, or others. 
                    </p>
                    <li id='dataretention' className='font-bold'>Data Retention and Deletion</li>
                    <ol className='list-disc pl-6 space-y-2'>
                        <li>
                            Retention
                        </li>
                        <p>
                            We retain account data, authentication records, device tokens, and operational metadata only as long as the account remains active, plus a limited period as needed for security, auditability, reliability, and legal compliance.
                        </p>
                        <li>
                            Deletion Requests/Account Cancellations
                        </li>
                        <p>
                            Deletion requests or account cancellations should be directed to privacy@docpgr.com or support@docpgr.com.
                        </p>
                        <li>
                            Verification
                        </li>
                        <p>We may require verification of identity and/or administrative authority before completing a deletion request.</p>
                        <li>
                            Timeline
                        </li>
                        <p>
                            We will process verified deletion requests within 30 days, unless a longer period is required for legal compliance or a security investigation.
                        </p>
                        <li>
                            Backups
                        </li>
                        <p>
                            Deleted data may remain in encrypted backups for a limited period before being overwritten or purged. Backup-retained data is not used for active processing except for disaster recovery.
                        </p>
                    </ol>
                    <li id='security' className='font-bold'>Security</li>
                    <p>
                        We utilize industry-standard encryption (TLS) for all data in transit and maintain strict access controls on our U.S. servers to prevent unauthorized access. No method of transmission or storage is completely secure, but we work to protect information using industry-standard practices. 
                    </p>
                    <li id='privacy' className='font-bold'>Children's Privacy</li>
                    <p>
                        DocPGR is not directed to children under 13, and we do not knowingly collect personal information from children. If you believe a child provided personal information, contact us and we will take steps to delete it. 
                    </p>
                    <li id='changes' className='font-bold'>Changes to This Policy</li>
                    <p>
                        We may update this policy periodically. The Effective Date at the top will indicate the most recent revision. 
                    </p>
                    <li id='contactus' className='font-bold'>Contact Us</li>
                    <p>
                        <strong>Email:</strong> privacy@docpgr.com 
                    </p>
                </ol>
            </div>
        </div>
    )
}